import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

// Surface expired admin sessions instead of failing silently mid-edit.
http.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes("/auth/")) {
      error.sessionExpired = true;
    }
    return Promise.reject(error);
  }
);

export const LOGO =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_faith-athletes-hub/artifacts/u8o85szp_WhatsApp%20Image%202026-07-27%20at%204.01.56%20PM.jpeg";

export const FALLBACK_PHOTO =
  "https://images.unsplash.com/photo-1640817764462-e916b4eb0e16?crop=entropy&cs=srgb&fm=jpg&q=85";

export const absoluteUrl = (url = "") =>
  url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;

export const downloadUrl = (url, filename, opts = {}) => {
  const p = new URLSearchParams({ url: absoluteUrl(url), filename });
  if (opts.position) p.set("position", opts.position);
  if (opts.story) p.set("story", "true");
  if (opts.watermark === false) p.set("watermark", "false");
  return `${API}/download?${p.toString()}`;
};

export const embedUrl = (url = "") => {
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
};
